module.exports = __webpack_public_path__ + "media/images/minus-a819a736c8b6acc5b4f370a1a44f8127.svg";